type Finding = {
  name?: string;
  count?: number;
  category?: string;
  description?: string;
  question_range?: string;
};

type Props = {
  data: {
    name?: string;
    result?: {
      findings?: Finding[];
      categories?: string[];
      risk_level?: string;
    };
  };
};

const SrqResult = ({ data }: Props) => {
  const findings = data?.result?.findings ?? [];
  const categories = data?.result?.categories ?? [];
  const riskLevel = data?.result?.risk_level ?? "-";
  const categoryLabel = categories.length > 0 ? categories.join(", ") : "-";

  return (
    <div className="py-4">
      <div className="w-full flex items-center justify-between gap-4">
        <strong className="py-4 block">{data?.name ?? "SRQ"}</strong>
        <div className="bg-blue-100 py-1 px-2 rounded-lg font-bold text-right">
          {riskLevel} - {categoryLabel}
        </div>
      </div>

      <div className="space-y-3">
        {findings.length > 0 ? (
          findings.map((finding, index) => (
            <div key={`${finding.name ?? "finding"}-${index}`}>
              <p className="font-semibold">
                {finding.name ?? "Temuan"}
                {typeof finding.count === "number" && ` (${finding.count})`}
              </p>
              <p>{finding.description ?? "-"}</p>
              {finding.question_range && (
                <small className="text-gray-500">
                  Rentang pertanyaan: {finding.question_range}
                </small>
              )}
            </div>
          ))
        ) : (
          <p>Tidak ada temuan.</p>
        )}
      </div>
    </div>
  );
};

export default SrqResult;
